import { ModalContext } from "app/app";
import { Icon } from "components/lib";
import { Fragment, useContext } from "react";
import styles from "./styles.module.scss";

export function Options() {
  const { modal, setModal } = useContext(ModalContext);

  return (
    <Fragment>
      {modal.name === "options" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.closeWrapper}>
              <div onClick={() => setModal({})}>
                <Icon image="x" size={40} color="#000" />
              </div>
            </div>
            <div className={styles.image}>
              <Icon image="file-text" size={40} color="#fcba03" />
            </div>
            <div className={styles.title}>{modal.data.title}</div>
            <div className={styles.description}>{modal.data.description}</div>
            <div className={styles.footer}>
              <div className={styles.buttons}>
                {modal.data.options.map((value, index) => {
                  return (
                    <button
                      className={value.featured ? styles.save : styles.cancel}
                      onClick={() => value.action()}
                      key={index}
                    >
                      {value.label}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
